import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { t } from 'src/lib/language';

const AddInvoiceContactButton = (props: ButtonProps) => {
  const { disabled } = props;
  const lang = useSelector((state: Store) => state.language.language);
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    dispatch(openModal({ modal: MODALS.addContact }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.add_contact')}
      placement="top-start">
      <span>
        <ActionButton
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.presets}
          onClick={handleOpen}
          disabled={disabled}>
          <AssignmentIndIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default AddInvoiceContactButton;
